export enum IconType {
   Warning = 'warning',
   Insight = 'insight',
}
